import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_a_tabs = _resolveComponent("a-tabs")
  const _component_review_list = _resolveComponent("review-list")
  const _component_app_list = _resolveComponent("app-list")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      activeKey: _ctx.activeKey,
      "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeKey = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "review",
          tab: "开通审核"
        }),
        _createVNode(_component_a_tab_pane, {
          key: "app",
          tab: "应用管理"
        })
      ]),
      _: 1
    }, 8, ["activeKey"]),
    (_ctx.activeKey === 'review')
      ? (_openBlock(), _createBlock(_component_review_list, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.activeKey === 'app')
      ? (_openBlock(), _createBlock(_component_app_list, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}